<template>
  <div class="content analytics">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <stats-card :class="{ selected: firstSelected }" @click.native="onCountTypeSelected('Total Redemptions')">
            <div slot="header">
              <p class="card-category">Total Redemptions</p>
            </div>
            <div slot="icon">
              <img src="@/assets/static/img/stats/total-redemptions.svg" alt="..."/>
            </div>
            <div slot="number">
              <h4 class="number">{{ rewardCounts.total }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>{{ timePeriod }}
            </div>
          </stats-card>
        </div>
        <div class="col">
          <stats-card :class="{ selected: secondSelected }" @click.native="onCountTypeSelected('New Redemptions')">
            <div slot="header">
              <p class="card-category">New Redemptions</p>
            </div>
            <div slot="icon">
              <img src="@/assets/static/img/stats/new-redemptions.svg" alt="..."/>
            </div>
            <div slot="number">
              <h4 class="number">{{ rewardCounts.new }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>{{ timePeriod }}
            </div>
          </stats-card>
        </div>
        <div class="col">
          <stats-card :class="{ selected: thirdSelected }" @click.native="onCountTypeSelected('Returning Redemptions')">
            <div slot="header">
              <p class="card-category">Returning Redemptions</p>
            </div>
            <div slot="icon">
              <img src="@/assets/static/img/stats/returning-redemptions.svg" alt="..."/>
            </div>
            <div slot="number">
              <h4 class="number">{{ rewardCounts.returning }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>{{ timePeriod }}
            </div>
          </stats-card>
        </div>
        <div class="col">
          <stats-card :class="{ selected: fourthSelected }" @click.native="onCountTypeSelected('Profile Clicks')">
            <div slot="header">
              <p class="card-category">Profile Clicks</p>
            </div>
            <div slot="icon">
              <img src="@/assets/static/img/stats/profile-clicks.svg" alt="..."/>
            </div>
            <div slot="number">
              <h4 class="number">{{ impressionCount.profile_clicks }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>{{ timePeriod }}
            </div>
          </stats-card>
        </div>
        <div class="col">
          <stats-card :class="{ selected: fifthSelected }" @click.native="onCountTypeSelected('Brand Impressions')">
            <div slot="header">
              <p class="card-category">Brand Impressions</p>
            </div>
            <div slot="icon">
              <img src="@/assets/static/img/stats/brand-impressions.svg" alt="..."/>
            </div>
            <div slot="number">
              <h4 class="number">{{ impressionCount.brand_impressions }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>{{ timePeriod }}
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <chart-card>
            <template slot="header">
              <div class="row">
                <div class="col-sm">
                  <h4 class="card-title">{{ countType }}</h4>
                </div>
                <div class="col-sm">
                  <overlay-dropdown :title="timePeriod" :options="time_periods" @onOptionSelected="onTimePeriodSelected" />
                </div>
              </div>
            </template>
          </chart-card>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <card class="card-rewards">
            <template slot="header">
              <div class="row">
                <div class="col">
                  <h5 class="title">Rewards</h5>
                </div>
                <div class="col">
                  <button type="button" class="btn-simple btn btn-edit" v-tooltip.top-center="editTooltip" @click="goToManageRewards">
                    <img class="edit" src="@/assets/static/img/edit.png" alt="..."/>
                  </button>
                </div>
              </div>
            </template>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Total</th>
                  <th scope="col">New</th>
                  <th scope="col">Returning</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in rewards" :class="{ 'off': !item.live }" :key="item.last_edited">
                  <th scope="row" class="align-text-bottom">{{item.title}}</th>
                  <td class="align-text-bottom">{{item.total}}</td>
                  <td class="align-text-bottom">{{item.new}}</td>
                  <td class="align-text-bottom">{{item.returning}}</td>
                </tr>
              </tbody>
            </table>
            <div class="footer">
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i>{{ timePeriod }}
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatsCard from '@/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from '@/components/UIComponents/Cards/ChartCard.vue'
  import OverlayDropdown from '@/components/UIComponents/Dropdowns/OverlayDropdown.vue'
  import Card from '@/components/UIComponents/Cards/Card.vue'

  export default {
    components: {
      StatsCard,
      ChartCard,
      OverlayDropdown,
      Card,
    },
    data () {
      return {
        time_periods: [
          "This Week",
          "Last Week",
          "Last 7 Days",
          "Last 30 Days",
          "Year To Date",
          "Last 12 Months"
        ],
        editTooltip: 'Edit Rewards',
        deleteTooltip: 'Delete',
      }
    },
    methods: {
      goToManageRewards: function () {
        this.$router.push('/rewards')
      },
      onTimePeriodSelected(time_period) {
        this.$store.dispatch('updateTimePeriod', time_period)
      },
      onCountTypeSelected(count_type) {
        this.$store.dispatch('updateCountType', count_type)
      },
      async obtainRewardCountsIfNecessary () {
        if (this.$store.getters.countsByTimePeriod(this.$store.state.time_period).length === 0) {
          this.$store.dispatch('obtainRewardCounts');
        }
      },
      async obtainImpressionCountsIfNecessary () {
        if (this.$store.getters.impressionCountByTimePeriod(this.$store.state.time_period) === undefined) {
          await this.$store.dispatch('obtainImpressionCounts');
        }
      },
      getCountDisplay(number) {
        var number_display = number;
        if (number >= 10000) {
          number_display = Math.floor(number_display / 100)
          number_display = number_display / 10
          number_display = number_display + 'k'
        }
        return number_display.toString()
      },
    },
    computed: {
      rewards() {
        const rewards = this.$store.getters.unArchivedRewards
        const counts = this.$store.getters.countsByTimePeriod(this.$store.state.time_period)

        for (var i = 0; i < rewards.length; i++) {
          const count = counts.find(count => count.id === rewards[i].id)

          if (count != null) {
            rewards[i].total = count.total
            rewards[i].new = count.new
            rewards[i].returning = count.returning
          } else {
            rewards[i].total = '-'
            rewards[i].new = '-'
            rewards[i].returning = '-'
          }
        }
        
        return rewards.sort(function(x, y) { return (x.live === y.live)? 0 : x.live? -1 : 1; });
      },
      rewardCounts() {
        const counts = this.$store.getters.countsByTimePeriod(this.$store.state.time_period)

        if (counts.length > 0) {
          var total = 0
          var returning = 0
          var new_count = 0
          for (var i = 0; i < counts.length; i++) {
            total += counts[i].total
            new_count += counts[i].new
            returning += counts[i].returning
          }

          return {
            total: this.getCountDisplay(total),
            new: this.getCountDisplay(new_count),
            returning: this.getCountDisplay(returning),
          }
        } else {
          return {
            total: '-',
            new: '-',
            returning: '-',
          }
        }
      },
      impressionCount() {
        var count = this.$store.getters.impressionCountByTimePeriod(this.$store.state.time_period)

        if (count === undefined) {
          return {
            profile_clicks: '-',
            brand_impressions: '-',
          }
        }

        count.profile_clicks = this.getCountDisplay(count.profile_clicks)
        count.brand_impressions = this.getCountDisplay(count.brand_impressions)

        return count
      },
      timePeriod() {
        return this.$store.getters.timePeriod;
      },
      countType() {
        return this.$store.getters.countType;
      },
      firstSelected() {
        return this.$store.getters.countType === 'Total Redemptions';
      },
      secondSelected() {
        return this.$store.getters.countType === 'New Redemptions';
      },
      thirdSelected() {
        return this.$store.getters.countType === 'Returning Redemptions';
      },
      fourthSelected() {
        return this.$store.getters.countType === 'Profile Clicks';
      },
      fifthSelected() {
        return this.$store.getters.countType === 'Brand Impressions';
      },
    },
    watch: {
      async timePeriod () {
        await this.obtainRewardCountsIfNecessary();
        await this.obtainImpressionCountsIfNecessary();
      },
    },
    async mounted () {
      this.$nextTick(() => {
        this.$emit('scrollTop', 0)
      });
      
      await this.obtainRewardCountsIfNecessary();
      await this.obtainImpressionCountsIfNecessary();
    }
  }
</script>
